export const toHumanReadableSize = (bytes: number): string => {
  if (!bytes) {
    return "Empty file";
  }
  const exp: number = Math.floor(Math.log(bytes) / Math.log(1024));

  return (
    (bytes / Math.pow(1024, exp)).toFixed(2) + " " + " KMGTP".charAt(exp) + "B"
  );
};

export const toKebabCase = (str: string) =>
  str.toLowerCase().replace(/[\s_]+/g, "-");

export const formatDate = (date: string | Date): string => {
  const d = new Date(date);
  // return d.toLocaleString();
  return `${d.toLocaleDateString("en-GB")} ${d.toLocaleTimeString()}`;
};
